import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { SaveDocumentCmd } from 'document/command/save-document.cmd';
import { CvTemplateOutput } from 'document/model/cv-template.output';
import { DocumentI18nInput } from 'document/model/document-i18n.input';
import { DocumentOutput } from 'document/model/document.output';
import { SaveDocumentApiMutation } from 'document/mutation/save-document.mutation';
import { DocumentApiPort } from 'document/port/document-api.port';
import { FetchCvTemplateDocumentsApiQuery } from 'document/query/fetch-cv-template-documents.query';
import { FetchDocumentsApiQuery } from 'document/query/fetch-documents.api-query';
import { FetchDocumentsQuery } from 'document/query/fetch-documents.query';
import { UserSessionPort } from 'user/port/user-session.port';

import { ApiAdapter } from '../../common/api.adpater';

@Injectable()
export class DocumentApiAdapter extends ApiAdapter implements DocumentApiPort {
	constructor(
		userSessionPort: UserSessionPort,
		translateService: TranslateService,
		private _fetchDocumentsApiQuery: FetchDocumentsApiQuery,
		private _saveDocumentApiMutation: SaveDocumentApiMutation,
		private _fetchCvTemplateDocumentsApiQuery: FetchCvTemplateDocumentsApiQuery
	) {
		super(userSessionPort, translateService);
	}

	public fetchDocuments(
		query: FetchDocumentsQuery
	): Observable<DocumentOutput[]> {
		return this.fetch$(this._fetchDocumentsApiQuery, {
			updateStartTimestamp: query.updateStartTimestamp,
			updateEndTimestamp: query.updateEndTimestamp,
			sortDirection: query.sortDirection,
			sortProperty: query.sortProperty,
			documentsId: query.documentsId,
			sectionsId: query.sectionsId,
			chunkSize: query.chunkSize,
			offset: query.offset,
			userId: query.userId,
			types: query.types,
			name: query.name,
		});
	}

	public saveDocument(cmd: SaveDocumentCmd): Observable<DocumentOutput> {
		return this.mutate$(this._saveDocumentApiMutation, {
			input: {
				id: cmd.id,
				type: cmd.type,
				userId: cmd.userId,
				phaseId: cmd.phaseId,
				moduleId: cmd.moduleId,
				localizations: cmd.localizations.map(
					(loc) =>
						({
							locale: loc.locale,
							name: loc.name,
							url: loc.url,
						} as DocumentI18nInput)
				),
			},
		});
	}

	public fetchCvTemplateDocuments(): Observable<CvTemplateOutput[]> {
		return this.fetch$(this._fetchCvTemplateDocumentsApiQuery);
	}
}
